<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li *ngIf="locations.visible" class="breadcrumb-item">
      <span *ngIf="locations.active">{{ 'menu_locations' | l10n }}</span>
      <div *ngIf="! locations.active">
        <a [routerLink]="['/city/list']">{{ 'menu_locations' | l10n }}</a>
        <div class="selected-value">{{ city?.name }}</div>
      </div>
    </li>
    <li *ngIf="otEvents.visible" class="breadcrumb-item">
      <span *ngIf="otEvents.active">{{ 'menu_otEvents' | l10n }}</span>
      <a *ngIf="! otEvents.active" [routerLink]="['/city/' + city?.id + '/ot/event/list']">{{ 'menu_otEvents' | l10n }}</a>
      <div class="selected-value">{{ otEvent?.name }}</div>
    </li>
    <li *ngIf="price.visible" class="breadcrumb-item">
      <span *ngIf="price.active">{{ 'menu_price' | l10n }}</span>
      <a *ngIf="! price.active" [routerLink]="['/city/' + city?.id + '/ot/event/' + otEvent?.id + '/registration/price']">{{ 'menu_price' | l10n }}</a>
    </li>
    <li *ngIf="person.visible" class="breadcrumb-item">
      <span *ngIf="person.active">{{ 'menu_person' | l10n }}</span>
      <a *ngIf="! person.active" [routerLink]="['/city/' + city?.id + '/ot/event/' + otEvent?.id + '/registration/person']">{{ 'menu_person' | l10n }}</a>
    </li>
    <li *ngIf="summary.visible" class="breadcrumb-item active" aria-current="page">{{ 'menu_summary' | l10n }}</li>
    <li *ngIf="success.visible" class="breadcrumb-item active" aria-current="page">{{ 'menu_success' | l10n }}</li>
  </ol>
</nav>
